import { IAncillaryAvailabilityRequest, IAncillaryAvailabilityResponse, IAncillaryPricingRequest, IAncillaryPricingResponse, IAncillarySummaryResponse, IModificationPricingInfo, IPnrInfoRequest, IResponse } from "@common/models";
import Api, { IOptions } from "@service/Api";
import { Action } from "./Proxy";

export function ancillary<T = IAncillaryAvailabilityRequest, U = IAncillaryAvailabilityResponse>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Ancillary", { ...options, raiseError: options?.raiseError ?? true });
    }
    return Promise.reject();
}

export function ancillaryPricing<T = IAncillaryPricingRequest, U = IAncillaryPricingResponse>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Ancillary/Pricing", { ...options, raiseError: options?.raiseError ?? true });
    }
    return Promise.reject();
}

export function ancillaryModifying<T = IAncillaryPricingRequest, U = IModificationPricingInfo>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Ancillary/Modify", { ...options, raiseError: options?.raiseError ?? true });
    }
    return Promise.reject();
}

export function ancillaryConfirm<T = IAncillaryPricingRequest, U = IPnrInfoRequest>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Ancillary/Confirm", { ...options, raiseError: options?.raiseError ?? true });
    }
    return Promise.reject();
}

export function ancillarySummary<T = IAncillaryAvailabilityRequest, U = IAncillarySummaryResponse>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Ancillary/Summary", { ...options, raiseError: options?.raiseError ?? false });
    }
    return Promise.reject();
}